import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";
import DropDownLocationInput from "../../../helperComponents/DropDownLocationInput";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

export default function AskLocation({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [country, setCountry] = useState("IN");
  const [state, setState] = useState();
  const [city, setCity] = useState();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.state) setState(loggedInUser.state);
      if (loggedInUser.city) setCity(loggedInUser.city);
    }
  }, []);

  console.log(state, city);

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Location"
      skipID={"locationOnboardingSkipped"}
      title={"Your Location"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        {/* <DropDownLocationInput
          type="COUNTRY"
          value={country}
          onChange={setCountry}
        /> */}
        <DropDownLocationInput
          style={{ width: "100%" }}
          country={country}
          type="STATE"
          value={state}
          onChange={setState}
        />
        <DropDownLocationInput
          style={{ width: "100%" }}
          country={country}
          state={state}
          type="CITY"
          value={city}
          onChange={setCity}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!state) return window.popupAlert("Please! select the state");
    if (!city) return window.popupAlert("Please! select the city");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { country, state, city },
      });
      setLoading(false);
      let newLoggedInUser = { ...loggedInUser, country, state, city };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
